import axiosRoot from 'axios';
//http://localhost:9000
const baseUrl = 'https://beautyalarawebservice-b6p7.onrender.com/api';

const axios = axiosRoot.create({
  baseURL: baseUrl,
});

export default axios;

export { axios };

export const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers['Authorization'] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers['Authorization'];
  }
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;

    if (response && response.status === 401) {
      if (!window.location.pathname.includes('/login')) {
        localStorage.removeItem('jwtToken');
        localStorage.removeItem('userId');
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

const ensureAuthToken = () => {
  const token = localStorage.getItem('jwtToken');
  if (token) {
    axios.defaults.headers['Authorization'] = `Bearer ${token}`;
  }
};

const ensureLeadingSlash = (url) => {
  return url.startsWith('/') ? url : `/${url}`;
};

export const get = async (url, config = {}) => {
  try {
    ensureAuthToken();
    
    const urlWithSlash = ensureLeadingSlash(url);
    
    console.log(`Making GET request to: ${baseUrl}${urlWithSlash}`);
    console.log("Authorization header:", axios.defaults.headers['Authorization']);
    
    const response = await axios.get(urlWithSlash, config);
    console.log(`Response from ${urlWithSlash}:`, response);
    return response.data;
  } catch (error) {
    console.error(`Error in GET request to ${url}:`, error);
    
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
      console.error('Response headers:', error.response.headers);
    } else if (error.request) {
      console.error('No response received:', error.request);
    } else {
      console.error('Error setting up request:', error.message);
    }
    
    throw error;
  }
};

export const getAll = async (url, config = {}) => {
  try {
    ensureAuthToken();
    
    const urlWithSlash = ensureLeadingSlash(url);
    
    const response = await axios.get(urlWithSlash, config);
    return response.data.items;
  } catch (error) {
    console.error(`Error in getAll request to ${url}:`, error);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
};

export const getById = async (url, config = {}) => {
  try {
    ensureAuthToken();
    
    const urlWithSlash = ensureLeadingSlash(url);
    
    const response = await axios.get(urlWithSlash, config);
    return response.data;
  } catch (error) {
    console.error(`Error in getById request to ${url}:`, error);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
};

export const post = async (url, payload, config = {}) => {
  try {
    ensureAuthToken();
    const body = payload?.arg ?? payload;
    
    const urlWithSlash = ensureLeadingSlash(url);
    
    console.log(`Making POST request to: ${baseUrl}${urlWithSlash}`);
    const response = await axios.post(urlWithSlash, body, config);
    console.log(`Response from POST ${urlWithSlash}:`, response);
    return response.data;
  } catch (error) {
    console.error(`Error in POST request to ${url}:`, error);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
};

export const put = async (url, payload, config = {}) => {
  try {
    ensureAuthToken();
    const body = payload?.arg ?? payload;
    
    const urlWithSlash = ensureLeadingSlash(url);
    
    console.log(`Making PUT request to: ${baseUrl}${urlWithSlash}`);
    const response = await axios.put(urlWithSlash, body, config);
    console.log(`Response from PUT ${urlWithSlash}:`, response);
    return response.data;
  } catch (error) {
    console.error(`Error in PUT request to ${url}:`, error);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
};

export const patch = async (url, payload = {}, config = {}) => {
  try {
    ensureAuthToken();
    const raw = payload?.arg ?? payload;
    const { id, ...rest } = raw;
    
    const baseUrlWithSlash = ensureLeadingSlash(url);
    const fullUrl = id ? `${baseUrlWithSlash}/${id}` : baseUrlWithSlash;
    
    console.log(`Making PATCH request to: ${baseUrl}${fullUrl}`);
    const response = await axios.patch(fullUrl, rest, config);
    console.log(`Response from PATCH ${fullUrl}:`, response);
    return response.data;
  } catch (error) {
    console.error(`Error in PATCH request to ${url}:`, error);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
};

export const deleteById = async (url, payload = {}, config = {}) => {
  try {
    ensureAuthToken();
    const raw = payload?.arg ?? payload;
    
    const urlWithSlash = ensureLeadingSlash(url);
    const fullUrl = `${urlWithSlash}/${raw}`;
    
    console.log(`Making DELETE request to: ${baseUrl}${fullUrl}`);
    const response = await axios.delete(fullUrl, config);
    console.log(`Response from DELETE ${fullUrl}:`, response);
    return response.data;
  } catch (error) {
    console.error(`Error in DELETE request to ${url}/${payload}:`, error);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
};

export const del = async (url, config = {}) => {
  try {
    ensureAuthToken();
    
    const urlWithSlash = ensureLeadingSlash(url);
    
    console.log(`Making DELETE request to: ${baseUrl}${urlWithSlash}`);
    const response = await axios.delete(urlWithSlash, config);
    console.log(`Response from DELETE ${urlWithSlash}:`, response);
    return response.data;
  } catch (error) {
    console.error(`Error in DELETE request to ${url}:`, error);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
};

export const save = async (url, payload = {}, config = {}) => {
  try {
    ensureAuthToken();
    const raw = payload?.arg ?? payload;
    const { id, ...values } = raw;

    const method = id ? 'put' : 'post';
    const baseUrlWithSlash = ensureLeadingSlash(url);
    const fullUrl = id ? `${baseUrlWithSlash}/${id}` : baseUrlWithSlash;

    console.log(`Making ${method.toUpperCase()} request to: ${baseUrl}${fullUrl}`);
    const response = await axios[method](fullUrl, values, config);
    console.log(`Response from ${method.toUpperCase()} ${fullUrl}:`, response);
    return response.data;
  } catch (error) {
    console.error(`Error in SAVE request to ${url}:`, error);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
};